import { VStack } from 'native-base';
import Tabs from 'ui/components/Tabs';

import { ActivityFormContainer } from '~/components/ActivityFormBuilderPresets/components/ActivityFormContainer';
import { MediaForm } from '~/components/MediaForm';
import Scaffold from '~/components/Scaffold';
import { colors } from '~/theme/colors';

import { AboutForm } from './AboutForm';
import { useOpportunityFormController } from './controller';
import { opportunityFormTabsElements } from './tabsElements';
import { OpprtunityFormTabPages } from './types';
import { WhenWhereForm } from './WhenWhereForm';

export const AddOpportunityForm = () => {
  const {
    tabsRef,
    currentTab,
    causeOptions,
    requirementOptions,
    formData,
    handleBack,
    handleContinue,
    isLoading,
    filteredAppsByPermissions,
    handleUpdateLocationOption,
  } = useOpportunityFormController();

  const renderTabs = () => {
    return {
      [OpprtunityFormTabPages.About]: (
        <AboutForm
          handleContinue={handleContinue}
          handleBack={handleBack}
          causeOptions={causeOptions}
          requirementOptions={requirementOptions}
          defaultValues={formData}
          isLoading={isLoading}
          connectedApps={filteredAppsByPermissions}
        />
      ),
      [OpprtunityFormTabPages.Media]: (
        <MediaForm
          handleBack={handleBack}
          handleContinue={handleContinue}
          defaultValues={formData}
          isLoading={isLoading}
        />
      ),
      [OpprtunityFormTabPages.WhenWhere]: (
        <WhenWhereForm
          handleBack={handleBack}
          handleContinue={handleContinue}
          isLoading={isLoading}
          handleUpdateLocationOption={handleUpdateLocationOption}
        />
      ),
    }[currentTab];
  };

  return (
    <Scaffold title="Add new ongoing opportunity" alignItemsChildren="center">
      <ActivityFormContainer>
        <VStack w="100%" alignItems="center" pb={10}>
          <Tabs
            ref={tabsRef}
            tabBgColor="transparent"
            tabWith="100%"
            tabTextColor={colors.primary['600']}
            tabIndicatorColor={colors.primary['600']}
            tabfocusedTextColor={colors.primary['600']}
            swipeEnabled={false}
            elements={opportunityFormTabsElements}
            currentTab={currentTab}
          />
        </VStack>

        {renderTabs()}
      </ActivityFormContainer>
    </Scaffold>
  );
};
